import { IQRCodeDecoderService } from './IQRCodeDecoderSerivce';
import { QRCodeDecorderService } from './qrcodeDecoderService';

export class QRCodeDecorderServiceBuilder {
    public static Instance(): IQRCodeDecoderService {
        return new QRCodeDecorderService();
    }
}
